// Manage the search params for filters using qs
import qs from 'qs';
import { defaultActiveFilters } from './defaultActiveFilters';
const typeMap = {
    list: 'listFilters',
    range: 'rangeFilters',
    boolean: 'booleanFilters',
    multiList: 'multiListFilters'
};
export function getActiveFiltersFromSearch(query) {
    if (!query || query.length === 0) {
        return defaultActiveFilters;
    }
    // Query may be a string (from location.search) or an object (from req.query)
    const initialSearchParams = typeof query === 'string'
        ? qs.parse(query, {
            ignoreQueryPrefix: true
        })
        : query;
    const typeMapValues = new Set(Object.keys(typeMap));
    const filterParams = Object.keys(initialSearchParams)
        .map(param => {
        return typeMapValues.has(param)
            ? { [param]: initialSearchParams[param] }
            : false;
    })
        .filter(Boolean);
    // If there are no filter keys in the search params, do nothing
    if (filterParams.length === 0)
        return defaultActiveFilters;
    let activeFilters = Object.assign({}, defaultActiveFilters);
    filterParams.forEach((filter) => {
        convertFilterQueryToActiveFilter({
            activeFilters,
            initialSearchParams,
            filter
        });
    });
    return activeFilters;
}
function convertFilterQueryToActiveFilter({ initialSearchParams, filter, activeFilters }) {
    switch (Object.keys(filter)[0]) {
        case 'list':
            return (activeFilters['listFilters'] = Object.keys(filter.list).map(id => {
                const filter = {
                    id,
                    values: initialSearchParams.list[id],
                    __typename: 'ListFilterInput'
                };
                return filter;
            }));
        case 'range':
            return (activeFilters['rangeFilters'] = Object.keys(filter.range).map(id => {
                const filter = {
                    id,
                    min: +initialSearchParams.range[id][0],
                    max: +initialSearchParams.range[id][1],
                    __typename: 'RangeFilterInput'
                };
                return filter;
            }));
        case 'boolean':
            return (activeFilters['booleanFilters'] = Object.keys(filter.boolean).map(id => {
                const filter = {
                    id,
                    value: JSON.parse(initialSearchParams.boolean[id]),
                    __typename: 'BooleanFilterInput'
                };
                return filter;
            }));
        case 'multiList':
            return (activeFilters['multiListFilters'] = Object.keys(filter.multiList).map(id => {
                const filter = {
                    id,
                    values: initialSearchParams.multiList[id],
                    __typename: 'MultiListFilterInput'
                };
                return filter;
            }));
        default:
            break;
    }
}
//# sourceMappingURL=filterParams.js.map